import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { recalculateUserSaldo } from '../services/recalculateUserSaldo.service';

export const recalculateUserSaldoThunk = createAsyncThunk(
  'userProfile/recalculateUserSaldo',
  async ({ userId, employerBusinessId }, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());
    const response = await recalculateUserSaldo(
      userId,
      employerBusinessId,
      activeEmployerInfo
    );
    return response;
  }
);
